"use client";

import { c as _c } from "react/compiler-runtime";
import { Language } from "@xefi/x-react/templates";
import { useFormik } from "formik";
import { t } from "i18next";
import "@/config/next-i18next.config";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { OptimizedImage } from "@/components/OptimizedImage";
import { flag_en, flag_fr } from "@/utils/languages";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useUserStore } from "@/store/useUserStore";
import { useCurrentUserQuery } from "./useCurrentUser";
import { userMutationService } from "../../services/users/UserMutationService";
export const useCountries = () => {
  const $ = _c(30);
  const {
    currentUser
  } = useUserStore();
  const {
    data: fluxUser
  } = useCurrentUserQuery();
  const queryClient = useQueryClient();
  const {
    i18n
  } = useTranslation();
  let t0;
  if ($[0] !== i18n) {
    t0 = lang => i18n.changeLanguage(lang);
    $[0] = i18n;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const changeLng = t0;
  const getLngFromLS = _temp;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["mutate_language"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== fluxUser) {
    t2 = async language => {
      if (fluxUser?.id && fluxUser.locale !== language) {
        await userMutationService.updateLanguage(fluxUser.id, language);
      }
    };
    $[3] = fluxUser;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== queryClient) {
    t3 = () => {
      queryClient.invalidateQueries({
        queryKey: ["current-user"]
      });
      queryClient.invalidateQueries({
        queryKey: ["requests"]
      });
      queryClient.invalidateQueries({
        queryKey: ["request_check"]
      });
      queryClient.invalidateQueries({
        queryKey: ["request_steps"]
      });
    };
    $[5] = queryClient;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = {
      mutationKey: t1,
      mutationFn: t2,
      onSuccess: t3
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    mutate
  } = useMutation(t4);
  let t5;
  if ($[10] !== currentUser?.locale) {
    t5 = getLngFromLS() || currentUser?.locale || "fr";
    $[10] = currentUser?.locale;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = {
      initialValues: {
        language: t5
      },
      onSubmit: _temp2,
      enableReinitialize: false
    };
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const formik = useFormik(t6);
  let t7;
  if ($[14] !== formik || $[15] !== mutate) {
    t7 = lang_0 => {
      formik.setFieldValue("language", lang_0);
      mutate(lang_0);
    };
    $[14] = formik;
    $[15] = mutate;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const changeLanguage = t7;
  let t8;
  let t9;
  if ($[17] !== changeLng || $[18] !== formik.values.language || $[19] !== i18n.language) {
    t8 = () => {
      const currentLang = formik.values.language || "fr";
      if (i18n.language !== currentLang) {
        changeLng(currentLang);
      }
    };
    t9 = [changeLng, formik.values.language, i18n.language];
    $[17] = changeLng;
    $[18] = formik.values.language;
    $[19] = i18n.language;
    $[20] = t8;
    $[21] = t9;
  } else {
    t8 = $[20];
    t9 = $[21];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[22] !== changeLng || $[23] !== formik.values.language) {
    t10 = () => {
      const lang_1 = formik.values.language || "fr";
      localStorage.setItem("i18nextLng", lang_1);
      changeLng(lang_1);
    };
    t11 = [formik.values.language, changeLng];
    $[22] = changeLng;
    $[23] = formik.values.language;
    $[24] = t10;
    $[25] = t11;
  } else {
    t10 = $[24];
    t11 = $[25];
  }
  useEffect(t10, t11);
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = [{
      flag: <OptimizedImage src={flag_fr} width={22} height={16} className="rounded-sm" priority={true} alt={"Drapeau fran\xE7ais"} />,
      label: t("country.french"),
      code: "fr"
    }, {
      flag: <OptimizedImage src={flag_en} width={22} height={16} className="rounded-sm" priority={true} alt="Drapeau anglais" />,
      label: t("country.english"),
      code: "en"
    }];
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const languages = t12;
  let t13;
  if ($[27] !== changeLanguage || $[28] !== formik) {
    t13 = {
      languages,
      currentLanguage: formik.values.language,
      changeLanguage,
      formik
    };
    $[27] = changeLanguage;
    $[28] = formik;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
function _temp() {
  return typeof window !== "undefined" ? localStorage.getItem("i18nextLng") : null;
}
function _temp2() {}